// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ZW-z","smallCardRow":"_W-z","largeCardRow":"aX-z","productSearchRow":"bX-z","curatedRow":"cX-z"};